import OAuth2ClientCredentialsInput from "./OAuth2ClientCredentialsInput"
import OAuth2ClientCredentialsSetup from "./OAuth2ClientCredentialsSetup"

export { OAuth2ClientCredentialsInput, OAuth2ClientCredentialsSetup };
